import {
  GridColDef,
  GridRenderCellParams,
  GridValidRowModel,
} from '@mui/x-data-grid';
import { ActionsCell } from '@components/data-table';
import { translate } from '@translations/i18n';

export const createActionsColumn = <T extends GridValidRowModel>({
  width,
  minWidth = 150,
  flex = 0,
  autoWidth = false,
  renderActions,
}: ICreateActionsColumnOptions<T>): GridColDef => {
  const resolvedWidth = autoWidth ? undefined : width ?? minWidth;

  return {
    field: 'actions',
    headerName: translate('tableHeaders.actions'),
    align: 'right',
    width: resolvedWidth,
    minWidth,
    flex,
    sortable: false,
    filterable: false,
    resizable: false,
    cellClassName: 'data-table-actions-cell',
    headerClassName: 'data-table-actions-header',
    renderCell: (params: GridRenderCellParams<T>) => {
      return <ActionsCell>{renderActions(params.row)}</ActionsCell>;
    },
  };
};
